export const getDescriptionMicroData = (isMicrodataExperimentEnable: boolean) => {
  return isMicrodataExperimentEnable
    ? {
        itemScope: true,
        itemType: 'http://schema.org/Offer',
      }
    : {};
};
